export default __webpack_public_path__ + "static/media/school3.bc79b689.webp";